export enum SigningPackageStatus {
  DRAFT = 'DRAFT',
  WAIITING_SIGNATURE = 'WAIITING_SIGNATURE',
  COMPLETED = 'COMPLETED',
  REJECTED = 'REJECTED',
  ERROR = 'ERROR',
}
